'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t from "../defs/Chats.js";
var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var a = (e, t2, o) => t2 in e ? f(e, t2, { enumerable: true, configurable: true, writable: true, value: o }) : e[t2] = o, m = (e, t2) => {
  for (var o in t2 || (t2 = {}))
    c.call(t2, o) && a(e, o, t2[o]);
  if (r)
    for (var o of r(t2))
      h.call(t2, o) && a(e, o, t2[o]);
  return e;
}, s = (e, t2) => i(e, p(t2));
const C = forwardRef((e, t$1) => /* @__PURE__ */ a__default.createElement(b, s(m({ ref: t$1 }, e), { weights: t })));
C.displayName = "Chats";
export {
  C as Chats
};
